import {Component, OnDestroy, OnInit} from '@angular/core';
import {gql} from '@apollo/client';
import {Apollo} from 'apollo-angular';
import {
  TenantListComponent_getTenants,
  TenantListComponent_getTenants_tenants_edges_node,
} from './__generated__/TenantListComponent_getTenants';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs';

const GET_TENANTS = gql`
  query TenantListComponent_getTenants {
    tenants {
      edges {
        node {
          id
          name
          anonymizedBilledClients {
            clientId
            date
          }
          coaches {
            edges {
              node {
                id
                firstName
              }
            }
          }
        }
      }
    }
  }
`;

@Component({
  selector: 'app-tenant-list',
  templateUrl: './tenant-list.component.html',
  styleUrls: ['./tenant-list.component.scss'],
})
export class TenantListComponent implements OnInit, OnDestroy {
  tenants: TenantListComponent_getTenants_tenants_edges_node[] = [];
  subscriptions: Subscription[] = [];

  constructor(
    private apollo: Apollo,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.apollo
        .watchQuery<TenantListComponent_getTenants>({
          query: GET_TENANTS,
        })
        .valueChanges.subscribe(output => {
          this.tenants = output.data.tenants.edges.map(edge => edge.node);
        }),
    );
  }

  onNavigate(id: string) {
    this.router.navigate(['../tenants', id], {
      relativeTo: this.route,
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
